import React from 'react';

const Campana = props => (
  <svg viewBox="0 0 50 50" {...props}>
    <g transform="rotate(15 14.375 12.465) translate(14, 8)">
      <path d="M15.56 2.75a7.819 7.819 0 014.297 2.097c1.476 1.417 2.29 3.307 2.29 5.318v4.69c0 1.588.484 3.126 1.399 4.448l1.711 2.474a.313.313 0 01-.257.49h-7.884c-.476 1.036-1.543 1.726-2.741 1.726-1.198 0-2.265-.69-2.74-1.725H3.75a.313.313 0 01-.257-.49l1.711-2.474a7.787 7.787 0 001.398-4.449v-4.622c0-3.734 2.813-6.894 6.542-7.475V1.25c0-.173.14-.313.313-.313h1.79c.173 0 .313.14.313.313v1.5zm5.538 17.167a10.057 10.057 0 01-1.366-5.062v-4.69a5.017 5.017 0 00-1.571-3.645 5.43 5.43 0 00-3.786-1.507h-.02c-2.944.01-5.337 2.354-5.337 5.22v4.622c0 1.782-.47 3.517-1.366 5.062h13.446z"  fill="#fff"/>
    </g>
  </svg>
);

export default Campana;
